import styled from "@emotion/styled";
export const StyledPeriodSelect = styled.div`
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  column-gap: 10px;
  color: #333333;

  .period {
    cursor: pointer;
    &.selected {
      cursor: default;
      color: #4353ff;
      &.is-homepage-pricing {
        color: var(--primary-color);
        font-weight: 700;
      }
      /* CRM classic: the selected period is blue per Figma, not the CRM
         product primary color. */
      &.crm-classic {
        color: #0073ea;
        font-weight: 700;
      }
    }
  }
`;
